import React from "react";
import { Button, Grid, Typography } from "@mui/material";
import { UserAccountDTO, AssignedContentCourse, UserRole } from "@beable/roster-backend-client-v1";
import ScheduleTable from "../../../Schedule/ScheduleTable";
import courseService from '../../../../services/CourseService';
import { Autorenew } from "@mui/icons-material";

interface UserCourseDataProps {
  user: UserAccountDTO;
  userRole: string | null;
  assignedCourses?: AssignedContentCourse[];
  siteId: number;
  academicYearId: string;
  userProvisioned: boolean;
}
export default function UserCourseData({
  user,
  userRole,
  assignedCourses,
  siteId,
  academicYearId,
  userProvisioned
}: UserCourseDataProps) {
  const courseScheduleData = assignedCourses && 
    assignedCourses.map((course) => ({
      ...course,
      startDate: course.startDt,
      endDate: course.endDt,
    }));

  const reprovisionAssigments = async (user: UserAccountDTO) => {
    const result = await courseService.reprovisionAssignments(siteId, user, academicYearId, userRole);

    if (result) {
      alert("Provision request submitted successfully");
    } else {
      alert("There was an error submitting your request.");
    }
  };

  function ReprovisionButton() {
    return (
      <Button
        variant="contained"
        color="primary"
        aria-label="reprovision"
        onClick={() => reprovisionAssigments(user)}
        data-testid="btn-reprovision"
        startIcon={<Autorenew fontSize="small" />}
        disabled={(!userProvisioned && userRole !== UserRole.administrator && !courseScheduleData?.length)}
      >
        Reprovision Schedule
      </Button>
    );
  }

  return (
    <Grid container>
      <Grid size={12}>
        {ReprovisionButton()}
      </Grid>
      <Grid size={12}>
        {courseScheduleData ? (
          <ScheduleTable
            data={courseScheduleData}
            showClasses={false}
            showLessons={false}
            showCourse={true}
          />
        ) : (
          <Typography>No courses scheduled</Typography>
        )}
      </Grid>
    </Grid>
  );
}
